import {Component, OnDestroy} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {PageBuilderStore} from "../page-builder.store";
import {
    HeaderStatsBannerModel
} from "@white-label/components/page-builder/models/header-stats-banner.model";
import {BannerModel} from "@white-label/components/page-builder/models/banner.model";
import {SponsorsModel} from "@white-label/components/page-builder/models/sponsors.model";
import {FaqModel} from "@white-label/components/page-builder/models/faq.model";
import {ReviewsModel} from "@white-label/components/page-builder/models/reviews.model";
import {TextModel} from "@white-label/components/page-builder/models/text.model";
import {ExternalCodeModel} from "@white-label/components/page-builder/models/external-code.model";
import {SectionModel} from "@white-label/components/page-builder/models/section.model";
import {ComponentTypes} from "@white-label/components/page-builder/models/model.map";
import {ContactsModel} from "@white-label/components/page-builder/models/contacts.model";
import {PageBuilderModel} from "@white-label/components/page-builder/models/page-builder.model";
import { CdkDragDrop, DragDropModule, moveItemInArray} from "@angular/cdk/drag-drop";
import {AiModel} from "@white-label/components/page-builder/models/ai/ai.model";
import {SubscriptionModel} from "@white-label/components/page-builder/models/subscription.model";
import {ButtonComponent} from "@cybfed/shared/new-components/buttons/button/button.component";
import {WhiteLabelService} from "@cybfed/core/services/web-site/white-label-service";
import {PopupHelperService} from "@cybfed/core/services/popup-helper.service";
import {StorageService} from "@cybfed/core/services/storage.service";
import {ActivatedRoute} from "@angular/router";
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {WhiteLabelTemplateService} from "@cybfed/core/services/web-site/white-label-template-service";
import {CarouselModel} from "@white-label/components/page-builder/models/carousel.model";
import {WhiteLabelPageService} from "@cybfed/core/services/web-site/white-label-page-service";
import {Subject, takeUntil} from "rxjs";
import {CardCarouselModel} from "@white-label/components/page-builder/models/card-carousel.model";
import {CardGridModel} from "@white-label/components/page-builder/models/card-grid.model";
import {EventManagerService} from "@cybfed/core/services/event-manager.service";
import {UpdateMetaTags} from "@cybfed/core/utils/update-meta-tags";
import {HowItWorksModel} from "@white-label/components/page-builder/models/how-it-works.model";
import {StatisticsModel} from "@white-label/components/page-builder/models/stats.model";
import {NgClass} from "@angular/common";
import {
    WhiteLabelSectionComponent
} from "@white-label/components/page-builder/layout/section-parts/white-label-section/white-label-section.component";



@Component({
    selector: 'app-page-builder',
    templateUrl: './page-builder.component.html',
    standalone: true,
    imports: [
        TranslateModule,
        DragDropModule,
        ButtonComponent,
        NgClass,
        WhiteLabelSectionComponent,
    ],
    providers: [
        WhiteLabelService,
        PopupHelperService,
        WhiteLabelTemplateService,
        WhiteLabelPageService
    ],
})
export class PageBuilderComponent implements OnDestroy{
    unsavedChanges = true;
    componentTypes = ComponentTypes;
    currentSlug: string = ''
    initialPageState: string = ''
    initialPageHeader: string = ''
    initialPageFooter: string = ''
    initialPageStyling: string = ''
    private onDestroy$ = new Subject<void>();

    constructor(public pageBuilderStore: PageBuilderStore,
                private whiteLabelService: WhiteLabelService,
                private whiteLabelTemplateService: WhiteLabelTemplateService,
                private metadata: UpdateMetaTags,
                private mainStoreService: MainStoreService,
                public route: ActivatedRoute,
                public whiteLabelPageService: WhiteLabelPageService,
                private eventManagerService: EventManagerService,
                private popupHelperService: PopupHelperService) {

        this.route.params.pipe(takeUntil(this.onDestroy$)).subscribe((params) => {
            this.currentSlug = params['slug']; // Extract 'slug' from params
            if(this.currentSlug){
                this.loadPageData()
            }else {
                let page = this.mainStoreService.whiteLabel.pageBuilding
                this.pageBuilderStore.page = new PageBuilderModel(page);
                this.metadata.updateMetaTags({
                    title: page.metaTitle,
                    description: page.metaDescription,
                    keywords: page.keywords,
                    cardImage: page.metaShareImage,
                    image: page.metaShareImage
                });
                this.saveInitialState()
            }
        });

        this.addEventListeners()

    }

    addEventListeners(){
        this.eventManagerService.savePageBuilderSectionEmitter.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            this.savePage()
        })
        this.eventManagerService.resetPageBuilderSectionEmitter.pipe(takeUntil(this.onDestroy$)).subscribe(() => {

        })

    }

    private saveInitialState(): void {
        // Save the initial state as a JSON string
        this.initialPageState = JSON.stringify(this.pageBuilderStore.page);
        this.initialPageHeader = JSON.stringify(this.mainStoreService.whiteLabel.header)
        this.initialPageFooter = JSON.stringify(this.mainStoreService.whiteLabel.footer)
        this.initialPageStyling = JSON.stringify(this.mainStoreService.whiteLabel.styling)

    }



    public hasUnsavedChanges(): boolean {
        const currentPageState = JSON.stringify(this.pageBuilderStore.page);
        const currentHeaderState = JSON.stringify(this.mainStoreService.whiteLabel.header);
        const currentFooterState = JSON.stringify(this.mainStoreService.whiteLabel.footer);
        const currentStylingState = JSON.stringify(this.mainStoreService.whiteLabel.styling);

        return (
            currentPageState !== this.initialPageState ||
            currentHeaderState !== this.initialPageHeader ||
            currentFooterState !== this.initialPageFooter ||
            currentStylingState !== this.initialPageStyling
        );
    }



    private loadPageData() {
        if (this.currentSlug) {
            this.whiteLabelPageService.getBySlug(this.currentSlug).subscribe((data: any) => {
                if (!data.hasError) {
                    const page = data.data.page.pageBuilding;
                    this.pageBuilderStore.page = new PageBuilderModel(page);
                    this.metadata.updateMetaTags({
                        title: page.metaTitle,
                        description: page.metaDescription,
                        keywords: page.keywords,
                        cardImage: page.metaShareImage,
                        image: page.metaShareImage
                    });
                    // ?
                    this.pageBuilderStore.page = new PageBuilderModel(data.data.page.pageBuilding)
                    this.saveInitialState()
                }
            });
        }
    }



    addNewSection(index: number, layout: string): void {
        switch (layout) {
            case 'ltr' :
                this.pageBuilderStore.page.sectionsLtr.splice(index + 1, 0, new SectionModel());
                break;
            case 'rtl' :
                this.pageBuilderStore.page.sectionsRtl.splice(index + 1, 0, new SectionModel());
                break;
            default :
                this.pageBuilderStore.page.sections.splice(index + 1, 0, new SectionModel());
                break;
        }
        // Insert a new SectionModel instance after the specified index

    }


    openAiSection(): void {
        this.pageBuilderStore.configurationTab = 'ai-builder';
        this.pageBuilderStore.sideBarIsOpen = true;
        this.pageBuilderStore.page.sections.splice(this.pageBuilderStore.page.sections.length-1, 1);
    }

    openSectionSubTypes($index: number, type: string, component: any = null){
        this.pageBuilderStore.page.sections[$index].type = type;
        this.pageBuilderStore.page.sections[$index].component = component;
        this.pageBuilderStore.page.sections[$index].sortOrder = $index;
        switch (component) {
            case ComponentTypes.hero:
                this.pageBuilderStore.page.sections[$index].data = new HeaderStatsBannerModel();
                this.pageBuilderStore.page.sections[$index].enableTitle = false;
                this.pageBuilderStore.page.sections[$index].enableBackgroundImage = false;
                break;
            case ComponentTypes.features:
                this.pageBuilderStore.page.sections[$index].data = new BannerModel();
                break;
            case ComponentTypes.banner_left_right:
                this.pageBuilderStore.page.sections[$index].data = new BannerModel();
                break;
            case ComponentTypes.banner_right_left:
                this.pageBuilderStore.page.sections[$index].data = new BannerModel();
                break;


            case ComponentTypes.hero_video:
                this.pageBuilderStore.page.sections[$index].data = new BannerModel();
                break;
            case ComponentTypes.hero_simple_app:
                this.pageBuilderStore.page.sections[$index].data = new BannerModel();
                break;
            case ComponentTypes.hero_live_stream:
                this.pageBuilderStore.page.sections[$index].data = new BannerModel();
                break;
            case ComponentTypes.hero_product:
                this.pageBuilderStore.page.sections[$index].data = new BannerModel();
                break;
            case ComponentTypes.hero_slider:
                this.pageBuilderStore.page.sections[$index].data = new CarouselModel();
                break;




            case ComponentTypes.stats:
                this.pageBuilderStore.page.sections[$index].data = new StatisticsModel();
                break;
            case ComponentTypes.how_it_works:
                this.pageBuilderStore.page.sections[$index].data = new HowItWorksModel();
                break;
            case ComponentTypes.grid:
                //TODO: add latest portfolio
                this.pageBuilderStore.page.sections[$index].data = new CardGridModel();
                break;
            case ComponentTypes.sponsor:
                this.pageBuilderStore.page.sections[$index].data = new SponsorsModel();
                break;
            case ComponentTypes.latestProducts:
                //TODO: add latest products
                this.pageBuilderStore.page.sections[$index].data = [];
                break;
            case ComponentTypes.faq:
                this.pageBuilderStore.page.sections[$index].data = new FaqModel();
                break;
            case ComponentTypes.contactUs:
                this.pageBuilderStore.page.sections[$index].data = new ContactsModel();
                break;
            case ComponentTypes.horizontalCarousel:
                this.pageBuilderStore.page.sections[$index].data = new CardCarouselModel();
                break;
            case ComponentTypes.aiComponent:
                this.pageBuilderStore.page.sections[$index].data = new AiModel();
                break;
            case ComponentTypes.reviews:
                this.pageBuilderStore.page.sections[$index].data = new ReviewsModel();
                break;
            case ComponentTypes.pricing:
                this.pageBuilderStore.page.sections[$index].data = new SubscriptionModel();
                break;
            case ComponentTypes.text:
                this.pageBuilderStore.page.sections[$index].data = new TextModel();
                break;
            case ComponentTypes.externalCode:
                this.pageBuilderStore.page.sections[$index].data = new ExternalCodeModel();
                break;
            default:
                break;
        }
        this.pageBuilderStore.componentData = this.pageBuilderStore.page.sections[$index].data;
        this.pageBuilderStore.sectionData = this.pageBuilderStore.page.sections[$index];
        this.pageBuilderStore.sideBarIsOpen = true;
        this.pageBuilderStore.configurationTab  = 'component-configuration';


    }

    removeSection(section: any, index: number): void {
        section.splice(index, 1);
    }

    drop(event: CdkDragDrop<any[]>) {
        if (event.previousIndex !== event.currentIndex) {
            // this.swapItems(event.previousIndex, event.currentIndex);
            moveItemInArray(this.pageBuilderStore.page.sections, event.previousIndex, event.currentIndex);
            this.updateSortOrder();
        }
    }

    swapItems(index1: number, index2: number) {
        const temp = this.pageBuilderStore.page.sections[index1];
        this.pageBuilderStore.page.sections[index1] = this.pageBuilderStore.page.sections[index2];
        this.pageBuilderStore.page.sections[index2] = temp;
    }

    updateSortOrder() {
        this.pageBuilderStore.page.sections.forEach((item: any, index: number) => {
            item.sortOrder = index + 1;
        });
    }
    updateWhiteLabelPage(){
        this.whiteLabelPageService.updateBySlug(this.currentSlug,{
            pageBuilding: this.pageBuilderStore.page,
            styling: this.mainStoreService.whiteLabel.styling,
            header: this.mainStoreService.whiteLabel.header,
            footer: this.mainStoreService.whiteLabel.footer,
        } ).subscribe((data: any) => {
            if(!data.hasError){
                this.saveInitialState()
                this.unsavedChanges = false
                this.popupHelperService.printSuccess()
            }else {
                this.popupHelperService.printError({text: data.errorMessages[0].msg})
            }
        })
    }
    savePage(){
        if(this.currentSlug){
            this.updateWhiteLabelPage();
        }else {
            let whiteLabelId = StorageService.getItem(StorageService.statics.whiteLabelId)
            this.whiteLabelService.update(whiteLabelId, {
                pageBuilding: this.pageBuilderStore.page,
                styling: this.mainStoreService.whiteLabel.styling,
                header: this.mainStoreService.whiteLabel.header,
                footer: this.mainStoreService.whiteLabel.footer,
            }).subscribe((data: any) => {
                if(!data.hasError){
                    this.mainStoreService.whiteLabel   = {...this.mainStoreService.whiteLabel, ...{
                            pageBuilding: this.pageBuilderStore.page,
                        }}
                    this.unsavedChanges = false
                    this.saveInitialState()
                    this.popupHelperService.printSuccess()

                    // const popupSettings = {
                    //     customClass: {
                    //         container:"z-index-9999",
                    //         popup: "bg-000 w-15",
                    //         confirmButton: "pink-button-imp",
                    //         htmlContainer: "color-white",
                    //     },
                    //     icon: 'question',
                    //     text:  this.translateService.instant('need_save_this_for_template'),
                    //     confirmButtonText: this.translateService.instant('yes'),
                    // }
                    // this.popupHelperService.printQuestion(popupSettings, whiteLabelId, this.saveTemplate, this)
                    // this.router.navigate(['/'])
                }else {
                    this.popupHelperService.printError({text: data.errorMessages[0].msg})
                }
            })
        }

    }

    saveTemplate(whiteLabelId: string){
        this.whiteLabelTemplateService.addByWhiteLabel(whiteLabelId).subscribe((data: any) => {
            if(!data.hasError){
                this.unsavedChanges = false
                this.popupHelperService.printSuccess()
            }else {
                this.popupHelperService.printError({text: data.errorMessages[0].msg})
            }
        })
    }

    ngOnDestroy(): void {
        // Emit to the onDestroy$ Subject to complete all subscriptions
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }


}
